const actionTypes = {
  SET_ALL_THEMES: 'SET_ALL_THEMES',
  UPSERT_THEME: 'UPSERT_THEME',
  DELETE_THEME: 'DELETE_THEME',
  SET_ALL_SUBTOPICS: 'SET_ALL_SUBTOPICS',
};

export function setAllThemes(themes) {
  return { type: actionTypes.SET_ALL_THEMES, themes };
}

export function upsertTheme(theme) {
  return { type: actionTypes.UPSERT_THEME, theme };
}

export function deleteTheme(themeId) {
  return { type: actionTypes.DELETE_THEME, themeId };
}

export function setAllSubTopics(subTopics) {
  return { type: actionTypes.SET_ALL_SUBTOPICS, subTopics };
}

export default function themeReducer(
  state = {
    themes: [],
    topics: [],
    subTopics: [],
  },
  action
) {
  switch (action.type) {
    case actionTypes.SET_ALL_THEMES: {
      const Topics = [];
      action.themes.forEach(({ topics }) => Topics.push(...topics));

      const SubTopics = [];
      Topics.forEach(({ subTopics }) => SubTopics.push(...subTopics));

      return {
        themes: action.themes,
        topics: Topics,
        subTopics: SubTopics,
      };
    }
    case actionTypes.UPSERT_THEME: {
      return {
        ...state,
        themes: [
          ...state.themes.filter((t) => t.id !== action.theme.id),
          action.theme,
        ],
      };
    }
    case actionTypes.DELETE_THEME: {
      return {
        ...state,
        themes: [...state.themes.filter((t) => t.id !== action.themeId)],
      };
    }
    case actionTypes.SET_ALL_SUBTOPICS: {
      return { ...state, subTopics: action.subTopics };
    }
    default:
      return state;
  }
}

export const themesSelector = (state) => state.themeReducer.themes;
